import { amazonHost } from "../../paths";

export default amazonHost + "landing/musicators-experience.jpg";
